import { actionCodes } from 'constants/automation';
import { reminderOptions } from 'constants/dropdownOptions';
import { formatUtcToUserLocalDatetime } from 'utils/utility_functions/timezone';

const parseReminderData = (data = []) => {
  let _reminders = [];
  data.forEach((value) => {
    let _reminder = reminderOptions.find((index) => index?.value === value?.reminder_expression);
    if (_reminder) {
      _reminders.push({
        value: _reminder.value,
        reminder_channel_type: value?.reminder_channel_type,
      });
    } else {
      let custom_reminder = value?.reminder_expression?.split('#');
      let obj = {
        value: 'custom',
        customValue: custom_reminder?.[0] ? parseInt(custom_reminder[0]) : 0,
        type: custom_reminder?.[1] ? custom_reminder[1] : 'minutes',
        reminder_channel_type: value?.reminder_channel_type,
        past_due: custom_reminder?.[2] ? custom_reminder[2] : '',
      };
      _reminders.push(obj);
    }
  });
  return _reminders;
};

const parseAction = (action, triggerCode, timezone) => {
  if (
    (action?.action_code === actionCodes.ACT_SEND_SECURE_MESSAGE || action?.action_code === actionCodes.ACT_SEND_TEXT_MESSAGE) &&
    triggerCode === 'TRIG_REVIEW_REQUEST'
  ) {
    return {};
  }
  if (action?.action_code === actionCodes.ACT_SHARE_FORM) {
    return {
      form: {
        contact_form_id: action?.action_description?.body?.form_id,
        form_name: action?.action_description?.body?.form_name,
      },
      contact_assignees: action?.action_description?.body?.contact_assignees?.[0],
    };
  } else if (action?.action_code === actionCodes.ACT_SEND_SECURE_MESSAGE) {
    let selectedMessageTo = [];
    if (action?.action_description?.body?.data?.body?.message_to) {
      selectedMessageTo = [
        ...(action?.action_description?.body?.data?.body?.message_to.map((item) => ({
          res_type: 'user',
          value: item.firm_user_id,
        })) || []),
      ];
    }
    if (action?.action_description?.body?.data?.body?.groups) {
      selectedMessageTo = [
        ...selectedMessageTo,
        ...(action?.action_description?.body?.data?.body?.groups.map((item) => ({
          res_type: 'user-group',
          value: item.group_id,
        })) || []),
      ];
    }
    if (action?.action_description?.body?.data?.body?.contact_assignees) {
      selectedMessageTo = [
        ...selectedMessageTo,
        ...(action?.action_description?.body?.data?.body?.contact_assignees.map((item) => ({
          res_type: undefined,
          value: item,
        })) || []),
      ];
    }
    if (action?.action_description?.body?.data?.body?.firm_user_assignees) {
      selectedMessageTo = [
        ...selectedMessageTo,
        ...(action?.action_description?.body?.data?.body?.firm_user_assignees.map((item) => ({
          res_type: undefined,
          value: item,
        })) || []),
      ];
    }
    return {
      creator_firm_user_id:
        action?.action_description?.body?.creator_firm_user_id || action?.action_description?.body?.data?.body?.message_sender_assignee,
      subject: action?.action_description?.body?.data?.body?.subject ?? '',
      message: action?.action_description?.body?.data?.body?.message ?? '',
      attachments: action?.action_description?.body?.data?.body?.attachment || [],
      selectedMessageTo,
    };
  } else if (action?.action_code === actionCodes.ACT_CREATE_DOCUMENT) {
    return {
      document_name: action?.action_description?.body?.document_name,
      document_format: action?.action_description?.body?.document_format,
      send_mail: action?.action_description?.body?.send_mail,
      contact_assignees: action?.action_description?.body?.contact_assignees || [],
      template: action?.action_description?.body?.template || '',
    };
  } else if (action?.action_code === actionCodes.ACT_EVENT_CREATE) {
    let assignTo = [];
    if (action?.action_description?.body?.guests) {
      assignTo = [
        ...(action?.action_description?.body?.guests.map((item) => ({
          res_type: 'user',
          value: item.firm_user_id,
        })) || []),
      ];
    }
    if (action?.action_description?.body?.groups) {
      assignTo = [
        ...assignTo,
        ...(action?.action_description?.body?.groups.map((item) => ({
          res_type: 'user-group',
          value: item.group_id,
        })) || []),
      ];
    }
    if (action?.action_description?.body?.contact_assignees) {
      assignTo = [
        ...assignTo,
        ...(action?.action_description?.body?.contact_assignees.map((item) => ({
          res_type: undefined,
          value: item,
        })) || []),
      ];
    }
    if (action?.action_description?.body?.firm_user_assignees) {
      assignTo = [
        ...assignTo,
        ...(action?.action_description?.body?.firm_user_assignees.map((item) => ({
          res_type: undefined,
          value: item,
        })) || []),
      ];
    }
    return {
      title: action?.action_description?.body?.title,
      eventStartTime: new Date(formatUtcToUserLocalDatetime(action?.action_description?.body?.meeting_start_time, timezone)),
      eventEndTime: new Date(formatUtcToUserLocalDatetime(action?.action_description?.body?.meeting_end_time, timezone)),
      meeting_due_date_period: action?.action_description?.body?.meeting_due_date_period,
      meeting_url: action?.action_description?.body?.conferencing_url,
      description: action?.action_description?.body?.description,
      attachments: action?.action_description?.body?.attachments || [],
      event_type: action?.action_description?.body?.event_type,
      location: action?.action_description?.body?.location,
      meeting_cycle: action?.action_description?.body?.meeting_cycle,
      reminders: parseReminderData(action?.action_description?.body?.reminder),
      assignTo: assignTo || [],
      event_with_schedule_date: action?.action_description?.body?.event_with_schedule_date,
      event_preference: action?.action_description?.body?.event_preference || '',
      assignee_reminder: action?.action_description?.body?.assignee_reminder || [],
    };
  } else if (action?.action_code === actionCodes.ACT_TASK_CREATE) {
    let assignTo = [];
    if (action?.action_description?.body?.assign_to) {
      assignTo = [
        ...(action?.action_description?.body?.assign_to.map((item) => ({
          res_type: 'user',
          value: item.firm_user_id,
        })) || []),
      ];
    }
    if (action?.action_description?.body?.groups) {
      assignTo = [
        ...assignTo,
        ...(action?.action_description?.body?.groups.map((item) => ({
          res_type: 'user-group',
          value: item.group_id,
        })) || []),
      ];
    }
    if (action?.action_description?.body?.contact_assignees) {
      assignTo = [
        ...assignTo,
        ...(action?.action_description?.body?.contact_assignees.map((item) => ({
          res_type: undefined,
          value: item,
        })) || []),
      ];
    }
    if (action?.action_description?.body?.firm_user_assignees) {
      assignTo = [
        ...assignTo,
        ...(action?.action_description?.body?.firm_user_assignees.map((item) => ({
          res_type: undefined,
          value: item,
        })) || []),
      ];
    }
    const subTask = action?.action_description?.body?.sub_task?.map((sTask) => {
      let subAssignTo = [];
      if (sTask?.assign_to) {
        subAssignTo = [
          ...(sTask?.assign_to.map((item) => ({
            res_type: 'user',
            value: item.firm_user_id,
          })) || []),
        ];
      }
      if (sTask?.groups) {
        subAssignTo = [
          ...subAssignTo,
          ...(sTask?.groups.map((item) => ({
            res_type: 'user-group',
            value: item.group_id,
          })) || []),
        ];
      }
      if (sTask?.contact_assignees) {
        subAssignTo = [
          ...subAssignTo,
          ...(sTask?.contact_assignees.map((item) => ({
            res_type: undefined,
            value: item,
          })) || []),
        ];
      }
      if (sTask?.firm_user_assignees) {
        subAssignTo = [
          ...subAssignTo,
          ...(sTask?.firm_user_assignees.map((item) => ({
            res_type: undefined,
            value: item,
          })) || []),
        ];
      }
      return {
        sub_task_description: sTask?.sub_task_description,
        sub_task_status: sTask?.sub_task_status,
        assignTo: subAssignTo || [],
      };
    });
    return {
      task_name: action?.action_description?.body?.task_name,
      priority: action?.action_description?.body?.priority,
      assignTo: assignTo,
      subTask: subTask || [],
      due_date_cycle: action?.action_description?.body?.due_date_cycle,
      due_date_period: action?.action_description?.body?.due_date_period,
      description: action?.action_description?.body?.description,
      reminders: parseReminderData(action?.action_description?.body?.reminder),
      attachments: action?.action_description?.body?.attachments || [],
      event_with_schedule_date: action?.action_description?.body?.event_with_schedule_date,
      event_preference: action?.action_description?.body?.event_preference || '',
    };
  } else if (action?.action_code === actionCodes.ACT_BULK_UPLOAD_FOLDER) {
    return {
      folderStructure: action?.action_description?.body?.folder_tree?.root || [],
    };
  } else if (action?.action_code === actionCodes.ACT_SEND_TEXT_MESSAGE) {
    return {
      contact_assignees: action?.action_description?.body?.contact_assignees,
      attachment: action?.action_description?.body?.attachments || [],
      message_body: action?.action_description?.body?.message_body,
    };
  }
};

export const parseAutomationData = (data, timezone) => {
  let parsedData = {
    automation_rule_id: data?.automation_rule_id,
    workflow_title: data?.workflow_title,
    workflow_description: data?.workflow_description,
    showDescription: Boolean(data?.workflow_description),
    is_lead_automation: data?.is_lead_automation,
    is_error: data?.is_error,
    is_deleted: data?.is_deleted,
    automation_status: data?.automation_status,
    pk: data?.pk,
    sk: data?.sk,
    trigger: {
      code: data?.workflow?.fire_on?.trigger_code,
      label: data?.workflow?.fire_on?.label,
      module: data?.workflow?.fire_on?.module,
    },
    filters:
      data?.workflow?.filter?.map((filter) => {
        const val = Object.keys(filter)
          .filter((key) => Object.values(filter[key]).length > 0 && key !== 'label' && key !== 'module')
          ?.map((key) => ({ condition: key, value: filter[key] }));
        if (val?.[0]?.condition === 'position') {
          return {
            label: filter?.label,
            role: val?.[0]?.value?.[0]?.role,
            value: val?.[0]?.value?.[0]?.data || [],
          };
        }
        if (val?.[0]?.condition === 'update') {
          // case stage filter
          if (
            val?.[0]?.value?.['case_description.case_stage.case_stage_id']?.length ||
            val?.[0]?.value?.['case_description.case_stage.sk']?.length
          ) {
            return {
              label: filter?.label,
              from: 'any',
              to:
                val?.[0]?.value?.['case_description.case_stage.case_stage_id']?.[1] ||
                val?.[0]?.value?.['case_description.case_stage.sk']?.[1],
            };
          }
          // lead stage filter
          return {
            label: filter?.label,
            from: val?.[0]?.value?.lead_stage?.[0],
            to: val?.[0]?.value?.lead_stage?.[1],
          };
        }
        return {
          label: filter?.label,
          value: val?.[0]?.value,
          condition: val?.[0]?.condition,
        };
      }) || [],
    actions:
      data?.workflow?.execution_sequence?.map((action) => {
        const delay = action?.delay?.split('#');
        return {
          action_code: action?.action_code,
          action_label: action?.action_label,
          delay:
            delay?.length > 0
              ? {
                  delayUnit: delay?.[1] || '',
                  value: delay?.[0] || '',
                  show: true,
                }
              : undefined,
          ...parseAction(action, data?.workflow?.fire_on?.trigger_code, timezone),
          timeTracker: {
            track_action_time: action?.action_description?.params?.qs_params?.track_action_time === 'true',
            manual_total_hours: action?.action_description?.params?.qs_params?.manual_total_hours || '',
            description: action?.action_description?.params?.qs_params?.notes || '',
          },
        };
      }) || [],
  };
  if (data?.workflow?.past_due_delay) {
    const pastDueDelay = data?.workflow?.past_due_delay?.delay_expression?.split('#');
    if (data?.workflow?.fire_on?.trigger_code === 'TRIG_REVIEW_REQUEST') {
      parsedData = {
        ...parsedData,
        count: pastDueDelay?.[0] || '',
        period: pastDueDelay?.[1] || '',
      };
    } else {
      parsedData.past_due_delay = data?.workflow?.past_due_delay?.delay_expression;
    }
  }

  return parsedData;
};
